import { render } from "./CachedDomains.vue?vue&type=template&id=ffc20ad0&scoped=true"
import script from "./CachedDomains.vue?vue&type=script&lang=js"
export * from "./CachedDomains.vue?vue&type=script&lang=js"

import "./CachedDomains.vue?vue&type=style&index=0&id=ffc20ad0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc20ad0"]])

export default __exports__